import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { VisaCountryService } from 'src/app/shared/services/visa-country.service';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { VisaTypeService } from 'src/app/shared/services/visa-type.service';
import { AdminDataType } from 'src/app/shared/enums/adminDataType';
import { AdminDataCreateDto } from 'src/app/shared/dtos/admindata/adminDataCreateDto';
import { AdminDataUpdateDto } from 'src/app/shared/dtos/admindata/adminDataUpdateDto';
import { VisitReasonService } from 'src/app/shared/services/visit-reason.service';
import { VisaLevelService } from 'src/app/shared/services/visa-level.service';
import { VisitReasonCreateDto, VisitReasonUpdateDto } from 'src/app/shared/dtos/visitReason/visitReasonDto';
import { VisaLevelCreateDto, VisaLevelUpdateDto } from 'src/app/shared/dtos/visaLevel/visaLevelDto';
import { ProfessionService } from 'src/app/shared/services/profession.service';
import { FamilyMembershipService } from 'src/app/shared/services/family-membership.service';
import { CreateProfessionDto, UpdateProfessionDto } from 'src/app/shared/dtos/profession/professionDto';
import { EducationService } from 'src/app/shared/services/education.service';
import { VisaLanguageService } from 'src/app/shared/services/visa-language.service';
import { VisaLanguageCreateDto, VisaLanguageUpdateDto } from 'src/app/shared/dtos/visaLanguage/visaLanguageDto';
import { ReligionService } from 'src/app/shared/services/religion.service';
import { VisaTypeCreateDto, VisaTypeUpdateDto } from 'src/app/shared/dtos/visaType/visaTypeDto';
import { VisaStatusService } from 'src/app/shared/services/visa-status.service';
import { CreateReligionDto, UpdateReligionDto } from 'src/app/shared/dtos/religion/religionDto';
import { CreateEducationDto, UpdateEducationDto } from 'src/app/shared/dtos/education/educationDto';
import { CreateCityDto, UpdateCityDto } from 'src/app/shared/dtos/city/cityDto';
import { CityService } from 'src/app/shared/services/city.service';
import { CreateFamilyMembershipDto , UpdateFamilyMembershipDto } from 'src/app/shared/dtos/familymembership/familyMembersipDto';


@Component({
  selector: 'app-visa-definition',
  templateUrl: './visa-definition.component.html',
  styleUrls: ['./visa-definition.component.scss']
})
export class VisaDefinationComponent implements OnInit {
  countries: any[] = [];
  visaLevels: any[] = [];
  visitReasons: any[] = [];
  professions: any[] = [];
  familyMemberships: any[] = [];
  educations: any[] = [];
  visaLanguages: any[] = [];
  religions: any[] = [];
  visaStatuses: any[] = [];
  cities: any[] = [];

  constructor(
    private visaCountryService: VisaCountryService,
    private visaTypeService: VisaTypeService,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private visitReasonService: VisitReasonService,
    private visaLevelService: VisaLevelService,
    private professionService: ProfessionService,
    private familyMembershipService: FamilyMembershipService,
    private educationService: EducationService,
    private visaLanguageService: VisaLanguageService,
    private religionService: ReligionService,
    private visaStatusService: VisaStatusService,
    private cityService: CityService,
  ) {}

  ngOnInit(): void {
    this.getCountries();
    this.getProfessions();
    this.getFamilyMemberships();
    this.getEducations();
    this.getVisaLanguages();
    this.getReligions();
    this.getVisaStatuses();
    this.getCities();
  }

  // Country CRUD
  async createCountry(event: any) {
  try{
    this.loadingService.show();
    const countryCreateDto: AdminDataCreateDto = {
      name: event.data.name,
      dataType: AdminDataType.VisaCountry, // AdminDataType enum'undan 'VisaCountry' kullanıyoruz
      description: event.data.description
    };
    await firstValueFrom(this.visaCountryService.create(countryCreateDto)); // AdminDataCreateDto ile gönderiyoruz
    this.getCountries();
    this.notificationService.show('Ülke başarıyla kaydedildi.');
  }
  catch{}
  finally {
    this.loadingService.hide();
  }
  }
  
  async updateCountry(event: any) {
    this.loadingService.show();
    if (event.newData) {
      const countryUpdateDto: AdminDataUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        dataType: AdminDataType.VisaCountry, // AdminDataType enum'undan 'VisaCountry' kullanıyoruz
        description: event.newData.description ?? event.oldData.description
      };
      await firstValueFrom(this.visaCountryService.update(countryUpdateDto)); // AdminDataCreateDto ile güncelleniyor
      this.getCountries();
      this.notificationService.show('Ülke başarıyla güncellendi.');
    }
    this.loadingService.hide();
  }

  async deleteCountry(event: any) {
    this.loadingService.show();
    await firstValueFrom(this.visaCountryService.delete(event.key));
    this.getCountries();
    this.notificationService.show('Ülke başarıyla silindi.');
    this.loadingService.hide();
  }


// Visit Reason CRUD


getCountries() {
  this.visaCountryService.getAll().subscribe((data: any[]) => {
    this.countries = data;
  });
}

async createProfession(event: any) {
  this.loadingService.show();
  try {
    const professionCreateDto: CreateProfessionDto = {
      name: event.data.name,
      description: event.data.description,
      visaCountryId: event.data.visaCountryId
    };
    await firstValueFrom(this.professionService.create(professionCreateDto));
    this.getProfessions(); // Listeyi yeniden al
    this.notificationService.show('Meslek başarıyla kaydedildi.');
  } catch{
  } finally {
    this.loadingService.hide();
  }
}

async updateProfession(event: any) {
  this.loadingService.show();
  try {
    if (event.newData) {
      const professionUpdateDto: UpdateProfessionDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        description: event.newData.description ?? event.oldData.description,
        visaCountryId: event.newData.visaCountryId ?? event.oldData.visaCountryId
      };
      await firstValueFrom(this.professionService.update(professionUpdateDto.id, professionUpdateDto));
      this.getProfessions(); // Listeyi yeniden al
      this.notificationService.show('Meslek başarıyla güncellendi.');
    }
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async deleteProfession(event: any) {
  this.loadingService.show();
  try {
    const professionId = event.data.id;
    await firstValueFrom(this.professionService.delete(professionId));
    this.getProfessions(); // Listeyi yeniden al
    this.notificationService.show('Meslek başarıyla silindi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async getProfessions() {
  this.loadingService.show();
  try {
    this.professions = await firstValueFrom(this.professionService.getList());
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async createFamilyMembership(event: any) {
  this.loadingService.show();
  try {
    const familyMembershipCreateDto: CreateFamilyMembershipDto = {
      name: event.data.name,
      description: event.data.description,
     visaCountryId: event.data.visaCountryId
    };
    await firstValueFrom(this.familyMembershipService.create(familyMembershipCreateDto));
    this.getFamilyMemberships(); // Listeyi yeniden al
    this.notificationService.show('Group Membership başarıyla kaydedildi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }


}

async updateFamilyMembership(event: any) {
  this.loadingService.show();
  try {
    if (event.newData) {
      const familyMembershipUpdateDto: UpdateFamilyMembershipDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
       visaCountryId: event.newData.visaCountryId ?? event.oldData.visaCountryId,
        description: event.newData.description ?? event.oldData.description
      };
      await firstValueFrom(this.familyMembershipService.update(familyMembershipUpdateDto.id, familyMembershipUpdateDto));
      this.getFamilyMemberships(); // Listeyi yeniden al
      this.notificationService.show('Group Membership başarıyla güncellendi.');
    }
  } catch  {
  } finally {
    this.loadingService.hide();
  }
}

async deleteFamilyMembership(event: any) {
  this.loadingService.show();
  try {
    const familyMembershipId = event.data.id;
    await firstValueFrom(this.familyMembershipService.delete(familyMembershipId));
    this.getFamilyMemberships(); // Listeyi yeniden al
    this.notificationService.show('Group Membership başarıyla silindi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }


}

async getFamilyMemberships() {
  this.loadingService.show();
  try {
    this.familyMemberships = await firstValueFrom(this.familyMembershipService.getList());
  } catch  {
  } finally {
    this.loadingService.hide();
  }
}


async createEducation(event: any) {
  this.loadingService.show();
  try {
    const educationCreateDto: CreateEducationDto = {
      name: event.data.name,
      description: event.data.description,
      visaCountryId: event.data.visaCountryId
    };
    await firstValueFrom(this.educationService.create(educationCreateDto));
    this.getEducations(); // Listeyi yeniden al
    this.notificationService.show('Öğrenim Durumu başarıyla kaydedildi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async updateEducation(event: any) {
  this.loadingService.show();
  try {
    if (event.newData) {
      const educationUpdateDto: UpdateEducationDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        description: event.newData.description ?? event.oldData.description,
        visaCountryId: event.newData.visaCountryId ?? event.oldData.visaCountryId
      };
      await firstValueFrom(this.educationService.update(educationUpdateDto.id, educationUpdateDto));
      this.getEducations(); // Listeyi yeniden al
      this.notificationService.show('Öğrenim Durumu başarıyla güncellendi.');
    }
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async deleteEducation(event: any) {
  this.loadingService.show();
  try {
    const educationId = event.data.id;
    await firstValueFrom(this.educationService.delete(educationId));
    this.getEducations(); // Listeyi yeniden al
    this.notificationService.show('Öğrenim Durumu başarıyla silindi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async getEducations() {
  this.loadingService.show();
  try {
    this.educations = await firstValueFrom(this.educationService.getList());
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async createVisaLanguage(event: any) {
  this.loadingService.show();
  try {
    const visaLanguageCreateDto: VisaLanguageCreateDto = {
      name: event.data.name,
      description: event.data.description,
      visaCountryId: event.data.visaCountryId, // Country ID seçimi
    };
    await firstValueFrom(this.visaLanguageService.create(visaLanguageCreateDto));
    this.getVisaLanguages(); // Listeyi yeniden al
    this.notificationService.show('Dil başarıyla kaydedildi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async updateVisaLanguage(event: any) {
  this.loadingService.show();
  try {
    if (event.newData) {
      const visaLanguageUpdateDto: VisaLanguageUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        description: event.newData.description ?? event.oldData.description,
        visaCountryId: event.newData.visaCountryId ?? event.oldData.visaCountryId,
      };
      await firstValueFrom(this.visaLanguageService.update(visaLanguageUpdateDto.id, visaLanguageUpdateDto));
      this.getVisaLanguages(); // Listeyi yeniden al
      this.notificationService.show('Dil başarıyla güncellendi.');
    }
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async deleteVisaLanguage(event: any) {
  this.loadingService.show();
  try {
    const visaLanguageId = event.data.id;
    await firstValueFrom(this.visaLanguageService.delete(visaLanguageId));
    this.getVisaLanguages(); // Listeyi yeniden al
    this.notificationService.show('Dil başarıyla silindi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async getVisaLanguages() {
  this.loadingService.show();
  try {
    this.visaLanguages = await firstValueFrom(this.visaLanguageService.getList());
  } catch {
  } finally {
    this.loadingService.hide();
  }
}
async getReligions() {
  this.loadingService.show();
  try {
    this.religions = await firstValueFrom(this.religionService.getList());
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

// Create a new religion
async createReligion(event: any) {
  this.loadingService.show();
  try {
    const religionCreateDto: CreateReligionDto = {
      name: event.data.name,
      description: event.data.description,
      visaCountryId: event.data.visaCountryId
    };
    await firstValueFrom(this.religionService.create(religionCreateDto));
    this.getReligions(); // Listeyi yeniden al
    this.notificationService.show('İnanç Durumu başarıyla kaydedildi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

// Update an existing religion
async updateReligion(event: any) {
  this.loadingService.show();
  try {
    if (event.newData) {
      const religionUpdateDto: UpdateReligionDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        description: event.newData.description ?? event.oldData.description,
        visaCountryId: event.newData.visaCountryId ?? event.oldData.visaCountryId
      };
      await firstValueFrom(this.religionService.update(religionUpdateDto.id, religionUpdateDto));
      this.getReligions(); // Listeyi yeniden al
      this.notificationService.show('İnanç Durumu başarıyla güncellendi.');
    }
  } catch {
  } finally {
    this.loadingService.hide();
  }
}


async deleteReligion(event: any) {
  this.loadingService.show();
  try {
    const religionId = event.data.id;
    await firstValueFrom(this.religionService.delete(religionId));
    this.getReligions(); // Listeyi yeniden al
    this.notificationService.show('İnanç Durumu başarıyla silindi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

// Fetch Visa Statuses
async getVisaStatuses() {
  this.loadingService.show();
  try {
    this.visaStatuses = await firstValueFrom(this.visaStatusService.getAll());
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

// Create a new Visa Status
async createVisaStatus(event: any) {
  this.loadingService.show();
  try {
    const visaStatusCreateDto: AdminDataCreateDto = {
      name: event.data.name,
      description: event.data.description,
      dataType: AdminDataType.VisaStatus // DataType için sabit değer
    };
    await firstValueFrom(this.visaStatusService.create(visaStatusCreateDto));
    this.getVisaStatuses(); // Listeyi yeniden al
    this.notificationService.show('Vize Durumu başarıyla kaydedildi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

// Update an existing Visa Status
async updateVisaStatus(event: any) {
  this.loadingService.show();
  try {
    if (event.newData) {
      const visaStatusUpdateDto: AdminDataUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        description: event.newData.description ?? event.oldData.description,
        dataType: AdminDataType.VisaStatus 
      };
      await firstValueFrom(this.visaStatusService.update(visaStatusUpdateDto));
      this.getVisaStatuses(); // Listeyi yeniden al
      this.notificationService.show('Vize Durumu başarıyla güncellendi.');
    }
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

// Delete a Visa Status
async deleteVisaStatus(event: any) {
  this.loadingService.show();
  try {
    const visaStatusId = event.data.id;
    await firstValueFrom(this.visaStatusService.delete(visaStatusId));
    this.getVisaStatuses(); // Listeyi yeniden al
    this.notificationService.show('Vize Durumu başarıyla silindi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async getCities() {
  this.loadingService.show();
  try {
    this.cities = await firstValueFrom(this.cityService.getList());
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

async createCities(event: any) {
  this.loadingService.show();
  try {
    const cityCreateDto: CreateCityDto = {
      name: event.data.name,
    };
    await firstValueFrom(this.cityService.create(cityCreateDto));
    this.getCities(); // Listeyi yeniden al
    this.notificationService.show('Şehir başarıyla kaydedildi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

// Update an existing Visa Status
async updateCities(event: any) {
  this.loadingService.show();
  try {
    if (event.newData) {
      const citiesUpdateDto: UpdateCityDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
      };
      await firstValueFrom(this.cityService.update(citiesUpdateDto.id, citiesUpdateDto));
      this.getCities(); 
      this.notificationService.show('Şehir başarıyla güncellendi.');
    }
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

// Delete a Visa Status
async deleteCities(event: any) {
  this.loadingService.show();
  try {
    const cityId = event.data.id;
    await firstValueFrom(this.cityService.delete(cityId));
    this.getCities();
    this.notificationService.show('Şehir başarıyla silindi.');
  } catch {
  } finally {
    this.loadingService.hide();
  }
}

generateCost(rowData: any): string {
  if (rowData.cost == null || rowData.cost == 0) { 
    return ''; 
  }
  return rowData.cost + ' $';
}

generateSaleAmount(rowData: any): string {
  if (rowData.saleAmount == null || rowData.saleAmount == 0) { 
    return ''; 
  }
  return rowData.saleAmount + ' $';
}



}
